import { addFollow } from '@eventbrite/follow-organizer-ebui';
import React from 'react';
import {
    FollowOrganizerProps,
    OrganizerPanelListingsProps,
    RemindMeProps,
} from '../../types';
import FollowOrganizerRoot from '../FollowOrganizer/FollowOrganizerRoot';
import OrganizerPanelListingsRoot from '../OrganizerPanel/OrganizerPanelListingsRoot';
import RemindMeRoot from '../RemindMe/RemindMeRoot';

type FollowOrganizerControllerProps = FollowOrganizerProps &
    OrganizerPanelListingsProps &
    RemindMeProps;

export const FollowOrganizerController = addFollow(
    (props: FollowOrganizerControllerProps) => {
        const {
            orgFacebook,
            orgTwitter,
            orgWebsite,
            organizerName,
            organizerId,
            organizerProfilePicture,
            organizerUrl,
            organizerDescription,
            organizerEventTitle,
            captchaKey,
            isAuthenticated,
            eventName,
            eventId,
            gaCategory,
            eventUrl,
            isRemindedEvent,
            gaSettings,
            userId,
            isGDPRCountry,
            organizerData,
        } = props;

        return (
            <>
                <RemindMeRoot
                    eventId={eventId}
                    eventUrl={eventUrl}
                    eventName={eventName}
                    gaCategory={gaCategory}
                    gaSettings={gaSettings}
                    isAuthenticated={isAuthenticated}
                    isGDPRCountry={isGDPRCountry}
                    isRemindedEvent={isRemindedEvent}
                    organizerId={organizerId}
                    organizerData={organizerData}
                    organizers={[organizerId]}
                    userId={userId}
                />
                <FollowOrganizerRoot
                    gaCategory={gaCategory}
                    gaSettings={gaSettings}
                    isAuthenticated={isAuthenticated}
                    isGDPRCountry={isGDPRCountry}
                    organizerId={organizerId}
                    organizerData={organizerData}
                    organizers={[organizerId]}
                    userId={userId}
                />
                <OrganizerPanelListingsRoot
                    organizerName={organizerName}
                    organizerId={organizerId}
                    organizerProfilePicture={organizerProfilePicture}
                    organizerUrl={organizerUrl}
                    organizerDescription={organizerDescription}
                    organizerEventTitle={organizerEventTitle}
                    captchaKey={captchaKey}
                    isAuthenticated={isAuthenticated}
                    eventName={eventName}
                    eventId={eventId}
                    gaCategory={gaCategory}
                    orgFacebook={orgFacebook}
                    orgTwitter={orgTwitter}
                    orgWebsite={orgWebsite}
                    gaSettings={gaSettings}
                    isGDPRCountry={isGDPRCountry}
                    organizerData={organizerData}
                    organizers={[organizerId]}
                    userId={userId}
                />
            </>
        );
    },
);
